// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// =========================

export default function TextButton({
    children,
    onClick,
    style,
    color,
    disabled,
    icon,
    textAlign,
}) {
    return (
        <motion.button
            styleName={` button ${color || ''} ${
                textAlign === 'right' ? 'align-right' : ''
            } ${textAlign === 'left' ? 'align-left' : ''} `}
            onClick={onClick}
            type="submit"
            style={
                ({
                    ...style,
                },
                disabled
                    ? {
                          pointerEvents: 'none',
                          opacity: 0.5,
                      }
                    : {})
            }
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
        >
            {children}
            {!!icon && <FontAwesomeIcon icon={icon} />}
        </motion.button>
    );
}
